import React, { useState } from 'react'
import { Badge, Drawer, Dropdown, Menu, Tabs } from "antd"
import pluralize from 'pluralize'
import Select from 'react-select'
import { Route, Switch, Link, useHistory, useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'
import Patient from '../reusable/patient'
import Confirm from '../reusable/confirm'

import PatientRequest from './patientRequest'
import SingleItemRequest from '../modals/singleItemRequest'
import IssueSingleRequest from '../modals/issueSingleRequest'
import SingleRequest from '../modals/singleRequest'

const { TabPane } = Tabs

const Requests = ({ path, department, onPerform  }) => {
    const [destination, setDestination] = useState()
    const [string, setString] = useState('')
    const [sString, setSString] = useState('')
    const [pString, setPString] = useState('')
    const [type, setType] = useState('')
    const [rqType, setRqType] = useState('')
    const [classif, setClass] = useState({ label: 'All', value: 'All' })
    const [key, setKey] = useState("0")
    const [stores, setStores] = useState([])
    const [store, setStore] = useState()
    const [itms, setItems] = useState([])
    const [dCount, setDCount] = useState([])
    const [pCount, setPCount] = useState([])
    const [ptns, setPatients] = useState([])

    const [visible, toggle] = useToggle(true)
    const [patientRq, togglePatientRq] = useToggle()

    const { id } = useParams()

    const history = useHistory()

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    const [, getDRequests] = usePet('departmentRequests', { store: id, type: "Received", classif: 'Pending' }, { notify: true, callback: ({ data }) => setDCount(data.count), manual: true })
    const [, getPRequests] = usePet('patientRequests', { store: id, requestType: "Inpatient", classif: 'Pending' }, { notify: true, callback: ({ data }) => setPCount(data.count), manual: true })

    const [
        { loading: drLoading, error: drError, fetch: fetchDR },
        { list: departmentRequests },
        { navigate: dNavigate, Paginate: DPaginate }
    ] = useListData('departmentRequests', {
        store: id,
        source: department,
        type,
        classif: classif?.value,
        string: sString
    }, { notify: true, manual: true }, 'requests')
    
    const [
        { loading: prLoading, error: prError, fetch: fetchPR },
        { list: patientRequests },
        { navigate: pRNavigate, Paginate: PPaginate }
    ] = useListData('patientRequests', {
        store: id,
        source: department,
        type,
        requestType: rqType,
        classif: classif?.value,
        string: sString
    }, { notify: true, manual: true }, 'requests')

    const [
        { loading: pLoading, error: pError, fetch: fetchPatients },
        { list: patients },
        { navigate: pNavigate }
    ] = useListData('ipPatients', { string: pString }, { notify: true }, 'patients')

    usePet('stores', { limit: 50, order: 1 }, { notify: true, callback: ({ data }) => {
        setStores(data.stores)
        let itm = data.stores.find(sto => sto === id)
        setStore(itm)
    } })

    const dRefresh = (str = "") => {
        setSString(str)
        dNavigate(1)
        fetchDR()
    }

    const pRefresh = (str = "") => {
        setSString(str)
        pRNavigate(1)
        fetchPR()
    }

    const refresh = () => {
        if (key === "1") {
            dRefresh()
        } else if (key === "2") {
            pRefresh()
            setRqType('Inpatient')
        } else if (key === "3") {
            pRefresh()
            setRqType('Consumables')
        }
    }

    const changeClassif = val => {
        setClass(val)
        refresh()
    }

    const onKeyChange = k => {
        setKey(k)
        setTimeout(refresh, 200)
    }

    const onComplete = ({ }, notif, ops) => {
        // onPerform()
        notif('Request has been sent', ops('success'))
        setItems([])
        onKeyChange(patientRq ? "2" : "1")
    }

    const [{ loading: dLoading }, requestForDepartment] = usePet('requestForDepartment', {
        source: department,
        destination: destination?._id,
        requests: itms
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Sending request...' } })

    const [{ loading: patLoading }, requestForPatient] = usePet('requestForPatients', {
        source: department,
        requestType: 'Inpatient',
        destination: destination?._id,
        patients: ptns.map(({ _id, items }) => ({
            id: _id,
            items
        }))
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Sending request...' } })

    const changeQty = (val, key) => {
        let temp = [...itms]
        temp[key].quantity = val

        setItems(temp)
    }

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const pSearch = str => {
        if (str?.trim()?.length > 2) {
            setPString(str)
            fetchPatients()
        }
    }

    const searchSent = str => {
        setSString(str)
        if (str?.trim()?.length > 2 || !str)
            refresh(str)
    }

    const close = () => {
        toggle()
        setTimeout(() => history.push(path), 300)
    }

    const onClose = () => {
        refresh()
        getDRequests()
        getPRequests()
    }

    const saveEntries = (entries, i) => {
        if (i >= 0 && ptns.length > i) {
            let temp = [...ptns]
            temp[i].items = entries
            setPatients(temp)
        }
    }

    const execute = () => {
        Confirm({
            title: 'Send Request?',
            message: 'Please confirm before performing this action',
            okText: 'Send Request',
            onOk: patientRq ? requestForPatient : requestForDepartment
        })
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    {
                        key === "0" ?
                        <button disabled={ patLoading || dLoading } onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Send Request</button>
                        : null
                    }
                </div>
            }
            width={1000}>
            <p className="font-extrabold text-3xl mb-0">Requests</p>
            <Tabs className="min-h-full" activeKey={ key } onChange={ onKeyChange }>
                <TabPane key="0" tab="New Request">
                    <span className="cursor-pointer" onClick={ togglePatientRq }>
                        <input
                            checked={ patientRq }
                            type="checkbox"
                            className="form-checkbox cursor-pointer h-5 w-5" />
                        <span className="text-gray-700 text-xs ml-2">Patient Request</span>
                    </span>
                    <div className="flex flex-wrap -mx-3 my-2">
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                Destination
                            </label>
                            <Select
                                isLoading={invLoading}
                                loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                value={destination}
                                onChange={setDestination}
                                options={stores ? stores.filter(sto => sto._id !== id).map(sto => ({ label: sto.name, value: sto._id, ...sto })) : [] }
                                placeholder="Select Destination" />
                        </div>
                    </div>
                    {
                        patientRq ?
                        <>
                            <div className="w-full mb-3">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                    Patients
                                </label>
                                <Select
                                    isMulti
                                    isLoading={pLoading}
                                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                    onInputChange={pSearch}
                                    value={ptns}
                                    onChange={setPatients}
                                    options={patients.map(pt => ({ label: `${pt?.name}${ pt?.ipNo ? ` (${pt?.ipNo})` : pt?.tempIpNo ? ` (${pt?.tempIpNo})` : '' }${ pt?.matIpNo ? ` (${pt?.matIpNo})` : '' }`, value: pt?._id, items: [], ...pt }))}
                                    placeholder="Search for Patients" />
                            </div>
                            {
                                ptns.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2 pl-4 text-center">
                                                    <div className="font-semibold">No.</div>
                                                </th>
                                                <th className="p-2 pl-4 text-left">
                                                    <div className="font-semibold">Name</div>
                                                </th>
                                                <th className="p-2 pl-4 text-left">
                                                    <div className="font-semibold">Items</div>
                                                </th>
                                                <th className="p-2" />
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                ptns.map((ptn, key) =>
                                                    <tr>
                                                        <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                                        <td className="p-2 pl-4 h-5">
                                                            <Patient patient={ ptn } />
                                                        </td>
                                                        <td className="p-2 pl-4 h-5">{ptn?.items?.length ?? 0} { pluralize('Items', ptn?.items?.length ?? 0) }</td>
                                                        <td className="p-2 pl-4 h-5 text-center">
                                                            <Link to={ `${path}/requests/new/${key}` }>
                                                                <button className="text-white hisani-btn-green-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">Items</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    : <div className="flex items-center justify-center h-28">
                                        <h2>You can add patients by clicking above</h2>
                                    </div>

                            }
                        </>
                        :
                        <>
                            <div className="w-full mb-3">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                    Items
                                </label>
                                <Select
                                    isMulti
                                    isLoading={invLoading}
                                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                    onInputChange={search}
                                    value={itms}
                                    onChange={setItems}
                                    options={items.map(itm => ({ label: itm.name, value: itm._id, item: itm._id, quantity: 0, ...itm }))}
                                    placeholder="Search for inventory item" />
                            </div>
                            {
                                itms.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2 pl-4 text-center">
                                                    <div className="font-semibold">No.</div>
                                                </th>
                                                <th className="p-2 pl-4 text-left">
                                                    <div className="font-semibold">Item</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Quantity</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                itms.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                                        <td className="p-2 pl-4 h-5">{item?.name}</td>
                                                        <td className="p-2 pl-4 h-5 text-center">
                                                            <div className="flex justify-center">
                                                                <input
                                                                    className="appearance-none block text-center max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                                                    id="grid-qty-item"
                                                                    value={ item.quantity }
                                                                    onChange={ e => changeQty(e.target.value, key) }
                                                                    placeholder={ `How many ${item.receivedIn.toLowerCase()}?` }
                                                                    type="number"/>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    : <div className="flex items-center justify-center h-28">
                                        <h2>You can add items by clicking above</h2>
                                    </div>

                            }
                        </>
                    }
                </TabPane>
                <TabPane key="1" tab={ <Badge count={ dCount }>Department Requests</Badge> }>
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen', 'Issued'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={drError}
                            loading={drLoading}
                            progress>
                            {
                                departmentRequests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Sent To</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                departmentRequests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ request.requestedBy?.name }</div>
                                                            <p className="text-gray-500 text-xs italic">{ request.requests.length } { pluralize('items', request.requests.length) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req?.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request.destination?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `${path}/requests/${request._id}` }><Menu.Item>View</Menu.Item></Link>
                                                                        {
                                                                            !request.seen &&
                                                                            <>
                                                                                <Menu.Item onClick={ () => null }>Edit</Menu.Item>
                                                                                <Menu.Item onClick={ () => null }>Delete</Menu.Item>
                                                                            </>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {DPaginate}
                    </div>
                </TabPane>
                <TabPane key="2" tab={ <Badge count={ pCount }>Inpatient Requests</Badge> }>
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen', 'Issued'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={prError}
                            loading={prLoading}
                            progress>
                            {
                                patientRequests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested For</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Sent To</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patientRequests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ request?.patient?.name } ({ request?.requestType === 'Consumables' ? request?.patient?.opNo : request?.patient?.ipNo ?? request?.patient?.tempIpNo })</div>
                                                            <p className="text-gray-500 text-xs italic">{ request.requests.length } { pluralize('items', request.requests.length) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req?.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request.destination?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `${path}/requests/${request._id}` }><Menu.Item>View</Menu.Item></Link>
                                                                        {
                                                                            !request.seen &&
                                                                            <>
                                                                                <Menu.Item onClick={ () => null }>Edit</Menu.Item>
                                                                                <Menu.Item onClick={ () => null }>Delete</Menu.Item>
                                                                            </>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {PPaginate}
                    </div>
                </TabPane>
                <TabPane key="3" tab={ <Badge count={ pCount }>Procedure Consumables</Badge> }>
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen', 'Issued'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={prError}
                            loading={prLoading}
                            progress>
                            {
                                patientRequests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested For</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Sent To</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patientRequests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ request?.patient?.name } ({ request?.requestType === 'Consumables' ? request?.patient?.opNo : request?.patient?.ipNo ?? request?.patient?.tempIpNo })</div>
                                                            <p className="text-gray-500 text-xs italic">{ request.requests.length } { pluralize('items', request.requests.length) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req?.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request.destination?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `${path}/requests/${request._id}` }><Menu.Item>View</Menu.Item></Link>
                                                                        {
                                                                            !request.seen &&
                                                                            <>
                                                                                <Menu.Item onClick={ () => null }>Edit</Menu.Item>
                                                                                <Menu.Item onClick={ () => null }>Delete</Menu.Item>
                                                                            </>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {PPaginate}
                    </div>
                </TabPane>
            </Tabs>
            <Switch>
                <Route path={ `${path}/requests/new/:index` }>
                    <PatientRequest 
                        patients={ ptns } 
                        path={ path } 
                        onPerform={ saveEntries } />
                </Route>
                <Route path={ `${path}/requests/:rq` }>
                    <SingleItemRequest path={ path } onPerform={ () => null } />
                </Route>
                <Route path={ `${path}/requests/:rq/issue` }>
                    <IssueSingleRequest onPerform={ onClose } />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Requests